import useToggle from '../../../../hooks/toggle';
import '../externaldoc.scss'
import React, { useEffect, useRef, useState } from "react";
import { selecteddocumentesign } from '../ReviewDocs';
import Esign from '../Esign';
import { useSelector } from 'react-redux';
import { getexternaldocuments, getSavedOfferDetails, sendleadinSoilAmmendum } from '../../../../api/transaction';
import { useParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { CSpinner } from '@coreui/react';

const LeadinSoilAddendum = () => {
    const { id,user }: any = useParams()
    const componentRef = useRef();
    const [loader,setloading] = useState(false)
    const [leadsoil, setLeadSoil] = useState({
        offer_id: id,
        purchase_agreement_date: null,
        property_knownas: '',
        no_report: false,
        report_have_been: false,
        seller1_value: "",
        seller2_value: "",
        seller1_date: null,
        seller2_date: null,
        buyer1_value: "",
        buyer2_value: "",
        buyer1_date: null,
        buyer2_date: null,
        witness1_value: "",
        witness2_value: "",
        witness1_date: null,
        witness2_date: null
    })
    const [offerdetails, setOfferDetails] = useState({});
    const [canvasmodal, setCanvasModal] = useToggle(false);
    const [htmlContent, setHtmlContent] = useState("");
    const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
        offerid: "",
        document_name: "",
        image_base64: "",
        sign_role: 1
    })
    // @ts-ignore
    const val = useSelector((state) => state?.new?.signset)
    //   const seller_date = ()=>{const d =  new Date();setLeadBasePaint({...leadbasepaint,seller1_date: new Date()})  }


    const ref = useRef(null)
    const printf = async () => {
        // window.print()
        handlePrint()

    }

    useEffect(()=>{
        if(val){
            if(user == "seller"){
                setLeadSoil({ ...leadsoil, seller1_value: val })
            }
            if(user == "client"){
                setLeadSoil({ ...leadsoil, buyer1_value: val })
            }
        }
        },[val])

    const send = async () => {
    setloading(true)
if(user === "seller"){
   
    if (leadsoil?.seller1_value) {
        const res = await sendleadinSoilAmmendum(leadsoil)
        if(res?.status == "success"){
            alert("Submitted Successfully")
        }
        else{
            alert("Something went wrong")
        }
    }
  
}  else if(user==="client"){

    if (leadsoil?.buyer1_value) {
        const res = await sendleadinSoilAmmendum(leadsoil)
        if(res?.status == "success"){
            alert("Submitted Successfully")
        }
        else{
            alert("Something went wrong")
        }
    }
}
setloading(false)
}

useEffect(()=>{
    (async function(){
        let offerdetails = await getSavedOfferDetails(id)
        setOfferDetails(offerdetails[0])
      const res =await getexternaldocuments(id,"leadsoiladdendum") 
      setLeadSoil({...leadsoil,
        purchase_agreement_date: res?.data?.purchase_agreement_date,
        // property_knownas: res?.data?.property_knownas,
        no_report: res?.data?.no_report,
        report_have_been: res?.data?.report_have_been,
        seller1_value: res?.data?.seller1_value,
        seller2_value: res?.data?.seller2_value,
        seller1_date: res?.data?.seller1_date,
        seller2_date: res?.data?.seller2_date,
        buyer1_value: res?.data?.buyer1_value,
        buyer2_value: res?.data?.buyer2_value,
        buyer1_date: res?.data?.buyer1_date,
        buyer2_date: res?.data?.buyer2_date,
        witness1_value: res?.data?.witness1_value,
        witness2_value: res?.data?.witness2_value,
        witness1_date: res?.data?.witness1_date,
        witness2_date: res?.data?.witness2_date
      })
    })()
  },[])

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
    return (
        <>
            <section className='leadbasepaint' ref={componentRef}>
                <table className="soil_addendum_table_main" style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 30 }}>
                    <tr>
                        <td>
                            <table style={{ width: "100%" }}>
                                <tr>
                                    <td style={{ width: "90%" }}><img style={{ width: '250px' }}
                                        src="https://storagemilforddev.blob.core.windows.net/images/logo.svg" /></td>

                                    <td  ><img style={{ width: "30px" }}
                                        src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg" alt="" />
                                        <img style={{ width: "30px" }}
                                            src="https://storagemilforddev.blob.core.windows.net/images/eh.svg" alt="" />
                                    </td>

                                </tr>

                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: "15px 0px" }}>
                            <span style={{ fontSize: "20px", fontWeight: 700 }}>Lead in Soil Addendum</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span>This addendum is in addition to and becomes a permanent part of the Purchase Agreement dated<input type="date" value={leadsoil?.purchase_agreement_date}
                                onChange={(e) => { setLeadSoil({ ...leadsoil, purchase_agreement_date: e?.target.value }) }}//@ts-ignore
                                style={{ outline: 'none', borderBottom: "1px solid black", width: '228px' }} />on the property known as <input type="text" value={offerdetails?.propertyAddress}
                                    // onChange={(e) => { setLeadSoil({ ...leadsoil, property_knownas: e?.target.value }) }}
                                    style={{ outline: 'none', borderBottom: "1px solid black", width: '78%' }} /></span>
                        </td>
                    </tr>


                    <tr>
                        <td style={{ padding: "30px 0px" }}>
                            <span>Purchase Agreement to be amended to include the following disclosure:</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: "15px 0px" }}>
                            <span style={{ color: "#3b0083", fontWeight: 700 }}>ENVIRONMENTAL CONDITIONS<br />
                                Lead in Soil</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <span>The housing is located in an area of Omaha Nebraska (generally Harrison Street to the South, Read Street to the North, 56th Street to
                                the West and East to the Missouri River) which EPA tests have shown may contain concentrations of lead in the soil that may pose an
                                unacceptable risk to human health and the environment (the “Omaha Nebraska Lead Site”). The Omaha Lead Site has been included on
                                EPA’s Superfund National Priorities List. However, the housing will only become part of the Omaha Lead Site if soils in its yard are tested
                                and contain lead concentrations in excess of applicable EPA action levels.</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: "15px 0px" }}>
                            <table style={{ width: "100%" }}>
                                <tr>
                                    <td style={{ width: "50%" }}>
                                        <span><input type="checkbox" checked={leadsoil?.no_report} onChange={(e) => { setLeadSoil({ ...leadsoil, no_report: !leadsoil?.no_report }) }} />No reports are available</span>
                                    </td>
                                    <td>
                                        <span><input type="checkbox" checked={leadsoil?.report_have_been} onChange={(e) => { setLeadSoil({ ...leadsoil, report_have_been: !leadsoil?.report_have_been }) }} />Reports have been given to the Buyer’s agent.</span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '15px 0px' }}>
                            <table>
                                <tr>
                                    <td style={{ textAlign: 'center' }}>
                                        <span><img id="seller1_value" src={user === "seller" ? (val || leadsoil?.seller1_value) : leadsoil?.seller1_value}
                                            className='text_input_soil_add' /></span>
                                        <span style={{ paddingRight: "250px" }}> Seller</span>
                                        <input type="date" name="" id="" 
                                        value={leadsoil?.seller1_date ? leadsoil?.seller1_date  : (user === "seller" && val || leadsoil?.seller1_value) ? new Date().toISOString().split('T')[0] : ""} 
                                        onChange={(e)=>setLeadSoil({...leadsoil,seller1_date:e.target.value})}
                                        />
                                        Date
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <span><img src={user?.toLowerCase() === "client" ? (val || leadsoil?.buyer1_value) : leadsoil?.buyer1_value}
                                            className='text_input_soil_add' /></span>
                                        <span style={{ paddingRight: "250px" }}> Buyer </span>
                                        <input type="date" name="" id="" 
                                         value={leadsoil?.buyer1_date ? leadsoil?.buyer1_date  : (user === "client" && val || leadsoil?.buyer1_value) ? new Date().toISOString().split('T')[0] : ""}
                                          onChange={(e)=>setLeadSoil({...leadsoil,buyer1_date:e.target.value})}
                                        />
                                        Date
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '15px 0px' }}>
                            <table>
                                <tr>
                                    <td style={{ textAlign: 'center' }}>
                                        <span><input type="text"
                                            className='text_input_soil_add' /></span>
                                        <span style={{ paddingRight: "250px" }}> Seller</span>Date
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <span><input type="text"
                                            className='text_input_soil_add' /></span>
                                        <span style={{ paddingRight: "250px" }}> Buyer </span>Date
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '15px 0px' }}>
                            <table>
                                <tr>
                                    <td style={{ textAlign: 'center' }}>
                                        <span><input type="date"
                                            className='text_input_soil_add' value={leadsoil?.witness1_date}
                                            onChange={(e) => { setLeadSoil({ ...leadsoil, witness1_date: e?.target.value }) }} /></span>
                                        <span style={{ paddingRight: "250px" }}>Witness </span>Date
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <span><input type="text"
                                            className='text_input_soil_add' /></span>
                                        <span style={{ paddingRight: "250px" }}>Witness </span>Date
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '15px 0px' }}>
                            <span style={{ fontWeight: 700, color: '#3b0083' }}>For information updated by the City of Omaha please visit http://www.omahalead.org</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '15px 0px' }}>
                            <span><img src="image/Screenshot (17).png" alt="" /></span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ padding: '15px 0px' }}>
                            <span>Other provisions: Earnest deposit to be delivered within (5) business days</span>
                        </td>
                    </tr>

                </table>

            </section>
            {
                user !== "agent" &&
                <>
             <React.Fragment>
<div className="d-flex align-items-center justify-content-end mb-2 mr-2">
    <button onClick={send} className="btn primaryColorBtn">Submit
    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
    </button>
    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button> 
</div>
          </React.Fragment>
            <Esign
                canvasmodal={canvasmodal}
                setCanvasModal={setCanvasModal}
                htmlContent={htmlContent}
                setHtmlContent={setHtmlContent}
                selecteddocumentesign={selecteddocumentesign}
                setselectedDocumentEsign={setselectedDocumentEsign}
                type={"seller"}
            ></Esign></>
            }
           
        </>
    )

}

export default LeadinSoilAddendum